import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_2 = { class: "remote-monitoring-events__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_DisplayTypes = _resolveComponent("DisplayTypes")!
  const _component_RemoteMonitoringEventTile = _resolveComponent("RemoteMonitoringEventTile")!
  const _component_RemoteMonitoringEventItemProxy = _resolveComponent("RemoteMonitoringEventItemProxy")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    state: _ctx.state,
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    statistics: false
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_FilterSection, {
        filter: _ctx.module.filter,
        "has-report": true,
        schemeSmall: _ctx.smallFilterLayout,
        schemeLarge: _ctx.bigFilterLayout,
        hasPinnedFields: "",
        defaultPinnedFields: ['card', 'watch_lists']
      }, null, 8, ["filter", "schemeSmall", "schemeLarge"])
    ]),
    statistic: _withCtx(() => [
      _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"]),
      _hoisted_1,
      _createVNode(_component_NButton, {
        class: "remote-monitoring-events__filter-item",
        type: "secondary",
        onClick: _ctx.acknowledgeAll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('remote_monitoring.acknowledge_all', 'f')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_NButton, {
        class: "remote-monitoring-events__filter-item",
        type: "secondary",
        onClick: _ctx.togglePlaying,
        icon: _ctx.playing ? 'pause' : 'play'
      }, null, 8, ["onClick", "icon"]),
      _createVNode(_component_DisplayTypes, {
        modelValue: _ctx.state.displayType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.displayType) = $event))
      }, null, 8, ["modelValue"])
    ]),
    items: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_RemoteMonitoringEventItemProxy, {
            key: item.id,
            display: _ctx.displayItemsMap ? _ctx.displayItemsMap[item.id] : false,
            "data-id": item.id
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_RemoteMonitoringEventTile, {
                key: item.id,
                item: item,
                "item-selected": _ctx.getIsItemSelected(item),
                "card-selected": _ctx.getIsCardSelected(item),
                "opened-item": _ctx.getOpenedItemType(item),
                "acknowledge-allowed": _ctx.acknowledgeAllowed,
                onSelect: () => _ctx.sidebarModule.toggleItemSelect(_ctx.pageSidebarType, item),
                onAction: (v, p) => _ctx.actionHandler(v, { ...item, ...p })
              }, null, 8, ["item", "item-selected", "card-selected", "opened-item", "acknowledge-allowed", "onSelect", "onAction"]))
            ]),
            _: 2
          }, 1032, ["display", "data-id"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["state", "onUpdate:scrollBottom"]))
}